<template>

    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/orderInfo' }">订单管理</el-breadcrumb-item>
                    <el-breadcrumb-item>统筹订单</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="orderInfo" class="demo-form-inline" label-width="120px" size="mini">
                    <el-row  type="flex" justify="end">
                        <el-form-item label="" >
                            <el-button type="info" @click="queryOrderInfo" size="mini">查询</el-button>
                            <el-button type="primary" @click="createExperimentNum" size="mini">生成实验编号</el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table
                    :data="orderInfos"
                    style="width: 100%"
                    v-if="tableHeight"
                    :height="tableHeight"
                    size="mini"
                    border
                    v-loading="loading"
                    empty-text="暂无数据"
                    :row-style="rowStyle">
                    <el-table-column fixed type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="orderCode" label="订单编号" width="200"></el-table-column>
                    <el-table-column prop="customerName" label="客户姓名" width="200"></el-table-column>
                    <el-table-column prop="carrierName" label="载体名称" show-overflow-tooltip width="150"></el-table-column>
                    <el-table-column prop="detectionPrimer" label="检测引物" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column prop="resistance" label="抗性" show-overflow-tooltip width="100"></el-table-column>
                    <el-table-column prop="bacterialStrain" label="菌株" show-overflow-tooltip width="100"></el-table-column>
                    <el-table-column prop="sampleNum" label="样品编号" width="200"></el-table-column>
                    <el-table-column prop="experimentNum" fixed label="实验编号" width="200"></el-table-column>
                    <el-table-column prop="insertFragment" label="插入片段" width="200"></el-table-column>
                    <el-table-column prop="isPurifyingDesc" label="是否已经纯化" width="200"></el-table-column>
                    <el-table-column prop="upstreamSite" label="上游位点" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column prop="downstreamSite" label="下游位点" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column prop="isSequencingDesc" label="是否测序" width="100"></el-table-column>
                    <el-table-column prop="sequenceCompany" label="送测公司" width="100"></el-table-column>
                    <el-table-column prop="positiveCloneNum" label="阳性克隆数" width="200"></el-table-column>
                    <el-table-column prop="sequencePrimerName" label="测序引物名称" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column prop="email" label="测序邮箱" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column prop="insertFragmentSeq" label="插入片段序列" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column prop="orderStatusDesc" label="订单状态" width="200"></el-table-column>
                    <el-table-column prop="orderResult" label="测序结果" width="200"></el-table-column>
                    <el-table-column prop="orderAmount" label="订单金额" width="200"></el-table-column>
                    <el-table-column prop="payWillingnessDesc" label="支付意愿确认" width="200"></el-table-column>
                    <el-table-column prop="customSettlementAmount" label="客户结算金额" width="200"></el-table-column>
                    <el-table-column prop="agentSettlementAmount" label="代理结算金额" width="200"></el-table-column>
                    <el-table-column prop="attrCustomerName" label="归属责任客户" width="200"></el-table-column>
                    <el-table-column prop="agentName" label="代理/收送样员" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="120">
                        <template slot-scope="scope">
                            <span style="margin-left:5px;">
                                <el-button @click="view(scope.row)" type="text" size="small">查看</el-button>
                            </span>
                          
                            <span style="margin-left:5px;">
                                <el-button @click.native.prevent="deleteRow(scope.$index, scope.row)" type="text" size="small">移除</el-button>
                            </span>
                         
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <!--  -->
        <el-drawer
            :title="title"
            :visible.sync="drawer"
            :direction="direction"
            :before-close="handleClose"
            size="80%">
                <OrderInfoUpdate v-if="isUpdate" :key="timer" :orderInfoProp="orderInfoProp"></OrderInfoUpdate>
                <OrderInfoView v-if="isView" :key="timer" :orderInfoProp="orderInfoProp"></OrderInfoView>
        </el-drawer> 
    </div>
    
</template>

<script>
import GlobeConstant from '../../assets/js/GlobeConstant';
import OrderInfoUpdate from './OrderInfoUpdate.vue';
import OrderInfoView from './OrderInfoView.vue';

export default {
    name:'OverallOrder',
    components: {
        OrderInfoUpdate,
        OrderInfoView,
    },
    data() {
        return {
            orderInfo:{
            },
            drawer: false,
            direction: 'rtl',
            orderInfos: [],
            currentPage: 1,
            pageSize:20,
            total:10,
            timer:'',
            orderInfoProp:{},
            title:"新增订单",
            dataStatuses:[],
            isReceipts: [],
            dialogFormVisible: false,
            formLabelWidth:"120px",
            titleView: "查看订单",
            drawerView: false,
            isUpdate: true,
            isView: true,
            isHasAuthority: false,
            isShowCustomerName: false,
            isShowCarrierName: false,
            isShowSampleNum: false,
            isShowExperimentNum: false,
            isShowIsSequencing: false,
            isShowPayWillingness: false,
            isShowAttributableCustomer: false,
            isShowRegionalAgency: false,
            isShowOverallPlan: false,
            labelStyle:{"text-align":"right"},
            totalOrderAmount: "",
            totalCommissionAmount:"",
            isDirector: false,
            isAdmin: false,
            isHasDel: false,
            confirmationReviews: [],
            isShowQuotationAmount: false,
            directors:[],
            commissioners:[],
            tableHeight: "",//表格高度
            confirmationReviewDisabled: false,
            isReceiptDisabled: false,
            isCommissionDisabled: false,
            isCommissions: [],
            orderStatuses:[],
            statusDisabled: true,
            loading: false,
            props: { multiple: true, checkStrictly: true},
            yesOrNo: [],
            payWillingnesses: [],
        }
    },
    methods: {
        update(row) {
            this.title = "修改订单";
            this.drawer = true;
            this.orderInfoProp = row;
            this.timer = new Date().getTime();
            this.isUpdate = true;
            this.isView = false;
        },
        view(row) {
            this.title = "查看订单";
            this.drawer = true;
            this.orderInfoProp = row;
            this.timer = new Date().getTime();
            this.isUpdate = false;
            this.isView = true;
        },
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            this.queryOrderInfo();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.queryOrderInfo();
        },
        handleClose(done) {
            if(!this.isView) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryOrderInfo();
                })
                .catch(() => {});
            } else {
                done();
            }
        },
        handleCloseView(done) {
            this.$confirm('确认关闭？')
            .then(()=> {
                done();
                this.queryOrderInfo();
            })
            .catch(() => {});
        },
        queryOrderInfo() {
            this.loading = true;
            this.$axios.post("/order/findToCreateExperimentNum",this.orderInfo).then(
                res=>{
                    if(res.data.status === "success"){
                        this.orderInfos = res.data.result;
                    } else {
                        this.$message.error(res.data.message);
                    }
                    this.loading = false;
                },
                error=>{
                    this.$message.error(error.message);
                    this.loading = false;
                }
            )
        },
        rowStyle({ row }) {
            if(row.dataColor === 'GREEN') {
                let styleJson = {
                    "background-color": "lightgreen"
                }
                return styleJson;
            } else if(row.dataColor === 'RED') {
                let styleJson = {
                    "background-color" : "#F08080"
                }
                return styleJson;
            } else if(row.dataColor === 'YELLOW') {
                let styleJson = {
                    "background-color": "lightyellow"
                }
                return styleJson;
            } else if(row.dataColor === 'GRAY') {
                let styleJson = {
                    "background-color": "lightgray"
                }
                return styleJson;
            } else if(row.dataColor === 'BLUE') {
                let styleJson = {
                    "background-color": "lightblue"
                }
                return styleJson;
            } else if(row.dataColor === 'PURPLE') {
                let styleJson = {
                    "background-color": "#E8B1FF"
                }
                return styleJson;
            } else if(row.dataColor === 'ORANGE') {
                let styleJson = {
                    "background-color": "#FFA500"
                }
                return styleJson;
            }
            
        },
        queryDicts(dictType) {
            let condition = {value:dictType};
            this.$axios.post("/dictionary/findByDictType",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        if(dictType === 'YES_NO') {
                            this.yesOrNo = res.data.result;
                        } else if(dictType === 'ORDER_STATUS') {
                            this.orderStatuses = res.data.result;
                        } else if(dictType === 'PAY_WILLINGNESS') {
                            this.payWillingnesses = res.data.result;
                        }
                    } else {
                        this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        getTableHeight() {
            let tableH = 230; //距离页面下方的高度
            let tableHeightDetil = window.innerHeight - tableH;
            if (tableHeightDetil <= 300) {
                this.tableHeight = 300;
            } else {
                this.tableHeight = window.innerHeight - tableH;
            }
        },
        createExperimentNum() {
            this.loading = true;
            var ids = [];
            this.orderInfos.forEach((item) => {
                ids.push(item.orderId);
            })
            var condition = {ids:ids};
            this.$axios.post("/order/createExperimentNum",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        this.$message({
                            type: 'success',
                            message: '实验编号生成成功!'
                        });
                        this.orderInfos = res.data.result;
                        this.loading = false;
                    } else {
                        this.$message.error(res.data.message);
                        this.loading = false;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                    this.loading = false;
                }
            )
        },
        deleteRow(index, row) {
            this.orderInfos.splice(index, 1);
            let condition = {
                id:row.orderId
            }
            this.$axios.post("/order/remove",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        this.$message({
                            type: 'success',
                            message: '移除成功!'
                        });
                    } else {
                        this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        }
    },
    mounted() {
        let _this = this;
        window.onresize = () => {
        if (_this.resizeFlag) {
            clearTimeout(_this.resizeFlag);
        }
        _this.resizeFlag = setTimeout(() => {
            _this.getTableHeight();
            _this.resizeFlag = null;
        }, 100);
        };

    },
    beforeDestroy() {
        this.$bus.$off(GlobeConstant.orderinfoupdate_to_orderinfo_close);
    },
    created() {
        this.getTableHeight();
        this.queryOrderInfo();
    }
    
}


</script>

<style scoped>

   .el-form {
       margin-top: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }
   .el-select {
        width: 220px;
    }

    .el-input {
        width: 220px;
    }
    .el-date-picker {
        width: 200px;
        background-color: green;
    }
    .el-cascader {
        width: 220px;
    }
    .margin-top {
        margin-top: 10px;
    }
    /* ::v-deep .el-table tbody tr:hover>td { 
        background-color: transparent !important;
    }
    ::v-deep .el-table__fixed-right tbody tr:hover>td {
        background-color: transparent !important;
    } */

    ::v-deep  .el-table .el-table__body tr.hover-row > td{
        background-color: #FFC0CB !important
    }

    ::v-deep  .el-tablle--enable-row-hover .el-table__body tr:hover > td{
        background-color:#FFC0CB !important
    }

    .emptyBg {
        display:block;
    }

</style>
